<script>
	import Header from '../page/side/_header.svelte'
    import Footer from '../page/side/_footer.svelte'
    import ViewTab from '../page/write/viewTab.svelte'

	import { onMount } from 'svelte'
    import { CheckDevice, Initialsetting } from '../script/_handle'
    import { DataReset, EditCheck } from '../script/handle/write'

    export let Num
    let checkDevice = 1
    
	onMount(async () => {
		checkDevice = CheckDevice()

        // 페이지 초기 세팅
		await Initialsetting()

        if(!($EditCheck)) {
            // 작성 데이터 초기화
            await DataReset()
        }
    })
</script>

<svelte:window on:resize={() => checkDevice = CheckDevice()} />

<svelte:head>
    {#if Num > 0}
	    <title>던전스쿼드 팀빌딩_수정</title>
    {:else}
	    <title>던전스쿼드 팀빌딩_작성</title>
    {/if}
</svelte:head>

<Header />

<div class="page">
    {#if checkDevice == 1}
        <div class="adfit pc vertical">
            <ins class="kakao_ad_area" style="display:none;"
            data-ad-unit = "DAN-FiXDp3vAveansjCX"
            data-ad-width = "160"
            data-ad-height = "600"></ins>
        </div>
    {:else}
        <div class="adfit mobile horizon">
            <ins class="kakao_ad_area" style="display:none;"
            data-ad-unit = "DAN-ejTHClwjUeFmA2p2"
            data-ad-width = "320"
            data-ad-height = "50"></ins>
        </div>
    {/if}

    <div class="content">
        <ViewTab bind:Num bind:Check={$EditCheck} />
        
        <div class="adfit mobile horizon">
            <ins class="kakao_ad_area" style="display:none;"
            data-ad-unit = "DAN-Ts61CY3bo3stg7DB"
            data-ad-width = "320"
            data-ad-height = "50"></ins>
        </div>
        
    </div>

    {#if checkDevice == 1}
        <div class="adfit pc vertical">
            <ins class="kakao_ad_area" style="display:none;"
            data-ad-unit = "DAN-ReGZIZUzMcwgqh1n"
            data-ad-width = "160"
            data-ad-height = "600"></ins>
        </div>
    {:else}
        <div class="adfit mobile horizon">
            <ins class="kakao_ad_area" style="display:none;"
            data-ad-unit = "DAN-eDXKnSwlGWeojks3"
            data-ad-width = "320"
            data-ad-height = "50"></ins>
        </div>
    {/if}

	<!-- Kakao Adfit -->
	<script type="text/javascript" src="//t1.daumcdn.net/kas/static/ba.min.js" async></script>
</div>

<Footer />

<style lang='scss'>
</style>